/* istanbul ignore file */
import React from 'react';
import { CreateForm } from 'framework/form';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import { usePresaleOutputService } from 'domain/shared/presale';
import PresaleOutputForm from 'domain/sales/opportunity/presale/output/form/PresaleOutputForm';
import { useShowContext } from 'framework/show';

const CreatePresaleOutputForm = ({ submitFormFunc, onCancel, ...props }: any) => {
  const { getValidationSchema } = usePresaleOutputService();
  const { data: showData } = useShowContext();
  const isContractRenewal = showData.getValueBySource('isContractRenewal');

  return (
    <CreateForm
      submitFormFunc={submitFormFunc}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        requiredResources: [],
        isContractRenewal,
      }}
      {...props}
    >
      <CreateTimelineItemLayout onCancel={onCancel}>
        <PresaleOutputForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreatePresaleOutputForm;
